import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import AddUserForm from './AddUserForm';
import { useAuth } from '@/contexts/AuthContext';

const AddUserDialog = ({ open, onOpenChange, onAddUser }) => {
  const { userProfile } = useAuth();
  const isTransporter = userProfile?.role === 'transporter';
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (userData) => {
    setIsSubmitting(true);
    try {
      await onAddUser(userData);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>{isTransporter ? 'Add New Driver' : 'Add New User'}</DialogTitle>
        </DialogHeader>
        <div className="overflow-y-auto flex-grow">
          <AddUserForm 
            onAddUser={handleSubmit} 
            onCancel={() => onOpenChange(false)} 
            isSubmitting={isSubmitting}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default AddUserDialog;